<script>
/**
 * @overview 游戏管理 - 入口列表
 *
 * @author
 */

import mapUtils, { $http, $list } from "@/utils";
import $store from "@/store";
import { mapState, mapGetters } from "vuex";
import { isFastExecute } from "../../utils/common";
import GameEditor from "./components/ListEditor.vue";
import GamePackEditor from "./components/GamePackEditor.vue";
import GameItem from "./components/ListItem.vue";
import ListConfigEditor from "./components/ListConfigEditor.vue";
import GamePreview from "./components/GamePreview.vue";
import AppCopyOrMove from "./../../components/AppCopyOrMove/index.vue";
import MenuItem from './../../components/MenuItem/index.vue';
import AddMenu from './AddMenu.vue';
import AppTree from './../../components/AppTree/index.vue';
import EditScene from './Scene/edit.vue';
import * as gameManageServer from '../../api/gameManage';
import * as materialManageServer from '../../api/materialManage';

export default {
  name: "ViewGame",

  components: {
    GamePackEditor,
    GameEditor,
    GameItem,
    ListConfigEditor,
    GamePreview,
    AppCopyOrMove,
    AppTree,
    EditScene,
    MenuItem,
    AddMenu,
  },

  data: () => ({
    searchText: '', // 搜索内容
    typeEnum: [800, 801, 802, 803], // 因为通用表达大类没提供类型id这边手动添加，从800开始 800【游戏场景】
    isEditScene: false, // 是否显示编辑游戏场景

    menusData: [], // 菜单所有数据
    menuOne: [{ id: '1', value: '课后游戏配置表' },
            { id: '2', value: '课中游戏模版' },
            { id: '3', value: '游戏类型管理' }], // 爷爷级菜单
    menuOneSelect: '', // 爷爷级菜单选中
    menu: [], // 一级菜单
    menuSelect: '', // 一级菜单选中值
    menuTwo: [], // 二级菜单
    menuTwoSelect: '', // 二级菜单选中值

    isAddMenu: false, // 是否添加二级目录
    grandpaId: -1, // 爷爷级目录id
    parentId: -1, // 新建目录父级id

    isCopyOrMove: false, // 复制或移动弹窗
    showType: 'copy', // 复制或移动类型
    showData: [], // 复制或移动数据集
    optId: '', // 操作id

    // 游戏包选择
    selectValue: '',
    // 游戏包下拉数据
    selectData: null,
    loading: {
      fetch: false,
    },

    list: {
      data: [],
    },

    query: {
      per_page: 23,
    },

    editor: {
      data: null,
      visible: false,
    },
    preview: {
      url: null,
      data: null,
      type: null,
      question_type: null,
      visible: false,
    },

    type: 0,
  }),

  computed: {
    ...mapState("game", ["types"]),
    ...mapGetters([
      'getPermissionsMoveMaterial',
      'getPermissionsCopyGame',
      'getPermissionsMoveGame',
      'getPermissionsCopyGameAfter',
      'getPermissionsMoveGameAfter',
    ]),
    // 判断当前是否是课中游戏模版
    isTemp() {
      return `${this.menuOneSelect}` === '2';
    },
    // 获取格式后的菜单数据
    getNewMenusData() {
      const list = JSON.parse(JSON.stringify(this.menusData));
      try {
      list.map((v) => {
        v.map((q) => {
          q.id = q.type_id;
          q.value = q.name;
          if (q.leaf && q.leaf.length > 0) {
            q.leaf = q.leaf.map(k => ({
                id: k.type_id,
                value: k.name,
              }));
          }
        });
      });
      } catch (e) {
        console.log('err==>', e);
      }
      return list;
    },
    // 游戏复制权限
    getFuzhiPermissions() {
      let state = false;
      switch (`${this.menuSelect}`) {
        case '666':
          state = this.getPermissionsCopyGameAfter;
          break;
        case '30':
          state = false;
          break;
        default:
          state = this.getPermissionsCopyGame;
      }
      return state;
    },
    // 游戏移动权限
    getMovePermissions() {
      let state = false;
      switch (`${this.menuSelect}`) {
        case '666':
          state = this.getPermissionsMoveGameAfter;
          break;
        case '30':
          state = this.getPermissionsMoveMaterial;
          break;
        default:
          state = this.getPermissionsMoveGame;
      }
      return state;
    },
    // 二级目录是否是未归类
    isUnTowLog() {
      let state = false;
      try {
        state = this.menuSelect === this.menuTwoSelect || `${this.menuTwoSelect}` === `-1`;
      } catch (e) {
        console.log('err==>', e);
      }
      return state;
    },
    // 是否是一级分类非课中和课外
    isGameOut() {
      return [1, '1'].includes(this.menuOneSelect);
    },
    isJinyong() {
      // 当选中课中或游戏包时 显示禁用按钮
      let state = false;
      if ([30, 666, '30', '666'].includes(this.menuSelect)) {
        state = true;
      }
      return state;
    },
    gameType() {
      return Number(this.$route.query["equal[type]"]);
    },
  },

  // beforeRouteEnter(to, from, next) {
  //   const initType = $store.state.game.types[0].value;
  //
  //   const query = $list.routeQuery({
  //     page: 1,
  //     "equal[type]": initType,
  //   }, to.query);
  //
  //   to.query["equal[type]"] ? next() : next({ ...to, query });
  // },

  created() {
    console.log(this.$route);
    // debugger
    // 获取菜单列表
    this.initMenu({ initial: true });
    // this.fetchList();
    // 获取游戏包下拉选择数据
    this.getGameData();
  },

  beforeRouteUpdate(to, from, next) {
    this.fetchList(to);

    next();
  },

  methods: {
    ...mapUtils("list", ["deleteAlert", "fetch", "routeQuery", "routePageIndex"]),

    gameUrl(edit = false) {
      if (this.isTemp) {
        if (edit === 1) {
          return '/game_theme';
        }
        return "/game_theme/index";
      }
      switch (`${this.menuSelect}`) {
        case '30':
          return "/resource";
        case '666':
          return "/game_pack";
        default:
          return "/game";
      }
    },
    // 游戏包数据
    getGameData() {
      if (!(this.selectData && this.selectData.length > 0)) {
        this.$list_fetch('/game_pack', { page: 1, per_page: 1000 })
          .then((res) => {
            this.selectData = res.data.map(v => ({
                label: v.name,
                value: v.id,
              }));
          }).catch((e) => {
            console.log(e);
        });
      }
    },
    // 初始化一级菜单和二级菜单
    async initMenu({ initial = false, twoFlash = false }) {
      try {
        this.selectValue = this.$route.query['equal[game_pack_id]'] && parseInt(this.$route.query['equal[game_pack_id]'], 10);
        const res = await gameManageServer.queryGameTypes();
        this.menusData = [res.game_types];

        // 添加课中和课后
        if (Array.isArray(this.menusData)) {
          // 获取课中分类
          const classForm = await materialManageServer.queryResourceTypes();
          const leafForm = classForm.courseware_resource_types.filter(v => v.type_id === 30)[0].leaf;

          // // 获取通用表单分类
          const customerForm = await gameManageServer.queryGameSceneType();
          this.menusData.push(customerForm.game_theme_types);
          console.log('800', customerForm);

          // 获取课后分类
          const classFormAfter = await gameManageServer.queryGameAfter();
          const leftFormAfter = classFormAfter.game_pack_types;
          this.menusData.push([{ type_id: 30, name: '课中表单', leaf: leafForm }, { type_id: 666, name: '课后表单', leaf: leftFormAfter }]);
          console.log('30', leafForm);
          console.log('666', leftFormAfter);
        }

        this.menu = res.game_types.map(v => ({
          id: v.type_id,
          value: v.name,
        }));

        // 如果是初始化 默认选中第一分类第一个
        if (initial) {
          this.menuOneSelect = this.$route.query.grandpaId || (this.menuOne && this.menuOne[0] && this.menuOne[0].id);
          this.menuSelect = this.$route.query.parentId || (this.menu && this.menu[0] && this.menu[0].id);
        }
        // 是否刷新二级分类 && 三级分类
        if (twoFlash || initial) {
          console.log('222==>', this.getNewMenusData[parseInt(this.menuOneSelect, 10) - 1]);
          this.menu = this.getNewMenusData[parseInt(this.menuOneSelect, 10) - 1];
          this.getNewMenusData[parseInt(this.menuOneSelect, 10) - 1].map((v) => {
            if (`${v.id}` === `${this.menuSelect}`) {
              this.menuTwo = v.leaf;
            }
          });
        }
        // 如果是初始化 第二分类默认第一个,如果路径上有二级分类则优先路径上的参数
        if (initial) {
          this.menuTwoSelect = this.$route.query['equal[type]'] || (this.menuTwo && this.menuTwo[0] && this.menuTwo[0].id);
          // this.queryType(this.menuTwoSelect);
          this.queryTypeOne(this.menuSelect, true);
        }
      } catch (e) {
        console.log('err==>', e);
      }
    },
    // 重新获取【课中游戏模版】-> 【课中场景配置】下的二级目录
    async getNewGameSceneTypes() {
      try {
        const arr = JSON.parse(JSON.stringify(this.menusData));
        const customerForm = await gameManageServer.queryGameSceneType();
        arr[1] = customerForm.game_theme_types;
        this.menusData = arr;
      } catch (e) {
        console.log('获取通用表单场景目录失败==>', e);
      }
    },
    // 爷爷级分类选中
    onBack(item) {
      // 更新父级分类数据，联动孙子级，显示最新数据
      console.log('menu-one', item);
      this.menuOneSelect = item.id;
      switch (`${this.menuOneSelect}`) {
        case '1':
          this.menu = this.getNewMenusData && this.getNewMenusData[0];
          break;
        case '2':
          this.menu = this.getNewMenusData && this.getNewMenusData[1];
          break;
        case '3':
          this.menu = this.getNewMenusData && this.getNewMenusData[2];
          break;
      }
      this.menuSelect = this.menu[0].id;
      this.menuTwo = this.menu[0].leaf;
      this.menuTwoSelect = this.menu[0].leaf && this.menu[0].leaf[0].id;
      const query = {
 page: 1, "equal[type]": this.menuTwoSelect, parentId: this.menuSelect, grandpaId: this.menuOneSelect,
};
      this.$list_routeQuery(query);
      this.fetchList();
    },
    // 一级分类选中
    queryTypeOne(e, initial = false) {
      try {
        this.menuSelect = e;
        console.log(this.getNewMenusData[parseInt(this.menuOneSelect, 10) - 1]);
        // debugger;
        // 获取二级分类
        this.getNewMenusData[parseInt(this.menuOneSelect, 10) - 1].map((v) => {
            if (v.id && `${v.id}` === `${e}`) {
              this.menuTwo = v.leaf;
            }
        });
        if (!initial) {
          this.menuTwoSelect = this.menuTwo && this.menuTwo[0] && this.menuTwo[0].id;
        }
        this.queryType(this.menuTwoSelect);
      } catch (err) {
        console.log('一级分类选中失败==>', err);
      }
    },
    queryType(value) {
      this.menuTwoSelect = value || -1;
      const query = {
 page: 1, "equal[type]": this.menuTwoSelect, parentId: this.menuSelect, grandpaId: this.menuOneSelect,
};
      // this.$route.query['equal[type]'] = value;
      // debugger

      // query["like[name]"] = "";
      // this.query["like[name]"] = "";
      // if (this.isGameOut && !this.selectValue) {
      //   delete query["equal[game_pack_id]"];
      //   delete this.$route.query["equal[game_pack_id]"];
      // } else {
      //   query["equal[game_pack_id]"] = this.selectValue;
      // }

      this.$list_routeQuery(query);
      this.fetchList();
    },

    queryName(nameQuery) {
      this.query['like[name]'] = this.searchText;
      this.query = { ...this.query, ...nameQuery };

      const query = { page: 1, ...this.query };

      if (this.isGameOut) {
        query['equal[game_pack_id]'] = this.selectValue;
      }

      this.$list_routeQuery(query);
    },

    onChangeSearch(value) {
      console.log('111-1', value);
      this.selectValue = value;
    },

    fetchList(route = this.$route) {
      this.query['like[name]'] = this.searchText;
      const query = { ...route.query, ...this.query };

      this.loading.fetch = true;

      this.type = this.menuSelect;

      // if (this.type === 666) delete query["equal[type]"];
      if (!this.isGameOut) delete query["equal[game_pack_id]"];


      // 当搜索为空时，不传递搜索字段
      if (!query["like[name]"]) {
        delete query["like[name]"];
        delete query["like[nick_name]"];
      }
      // 为课中时候，搜索字段变为nick_name
      const newQuery = JSON.parse(JSON.stringify(query));

      if (this.type === 30 && newQuery['like[name]']) {
        newQuery['like[nick_name]'] = newQuery['like[name]'];
        delete newQuery['like[name]'];
      }
      console.log(111, newQuery);

      // 兼容通用表单使用type_id
      if (this.isTemp && newQuery['equal[type]']) {
        newQuery['equal[type_id]'] = newQuery['equal[type]'];
        delete newQuery['equal[type]'];
      }

      this.$list_fetch(this.gameUrl(), newQuery)
        .then((data) => {
          const res = data;
          res.data.map((v) => {
            if (v.type_id && !v.id) {
              v.id = v.type_id;
            }
          });
          this.list = res;
        })
        .finally(() => {
          this.loading.fetch = false;
        });
    },

    // 刷新页面数据，并更新目录数据
    fetchList2() {
      // 如果课中表单编辑或新增时，异步刷新a【课中游戏模版】【课中场景】下的目录
      if (`${this.menuOneSelect}` === '3' && `${this.menuSelect}` === '30') {
        this.getNewGameSceneTypes();
      }
      // this.initMenu({ initial: true });
      this.fetchList();
    },

    gameDelete(id) {
      this.$list_deleteAlert(id, this.list.data, "游戏", this.gameUrl(1));
    },

    gameFuzhi(item) {
      console.log('复制==>');
      this.optId = item.id;
      // this.showCopyOrMove('copy');
      const obj = {
        30: 'copyGame',
        666: 'copyGameAfter',
        2: 'copyGameScene',
      };
      // 默认复制类型
      let key = 'copyGameTypes';
      switch (`${this.menuOneSelect}`) {
        case '2':
          // 课中游戏模版
          key = obj[`${this.menuOneSelect}`];
          break;
        case '3':
          // 游戏类型管理 课中/课后
          key = obj[`${this.menuSelect}`];
          break;
      }
      !isFastExecute() && gameManageServer[key]({ id: item.id })
              .then((res) => {
                if (res) {
                  this.$message.success('复制成功');
                  this.clearAll();
                  this.fetchList();
                }
              })
              .catch((err) => {
                this.$message.error('复制失败');
              });
    },

    gameMove(item) {
      console.log('移动');
      this.optId = item.id;
      this.showCopyOrMove('move');
    },

    // 复制或移动业务
    showCopyOrMove(type) {
      this.isCopyOrMove = true;
      this.showType = type;
      let logs = [];
      // TODO 获取复制或移动的数据
      switch (type) {
        case 'copy':
          this.showData = [{ key: 'sdfsf', value: 'ddd' }, { key: '1', value: 'dddddddd' }];
          break;
        case 'move':
          logs = this.menuTwo.map(v => ({ key: v.id, value: v.value }));
          this.showData = logs && logs.filter(v => (`${v.key}` !== `${this.menuSelect}` && `${v.key}` !== `${this.menuTwoSelect}`));
          break;
        default:
      }
    },

    // 复制或移动回调
    onCopyOrMove(select, type) {
      try {
        console.log(select, type);
        switch (type) {
          case 'copy':
            console.log('复制回调==>', type);
            break;
          case 'move':
            console.log('移动回调==>', type);
            this.moveEnd({ id: this.optId, type_id: select });
            break;
          default:
        }
        this.clearAll();
        this.fetchList();
      } catch (e) {
        this.$message.error('操作失败', e);
      }
    },

    // 移动
    async moveEnd(obj) {
      try {
        if (this.isTemp) {
          await gameManageServer.moveGameScene(obj);
        } else {
          switch (this.menuSelect) {
            case 30:
              await materialManageServer.moveResource(obj);
              break;
            case 666:
              await gameManageServer.moveGameAfter(obj);
              break;
            default:
              await gameManageServer.moveGameTypes(obj);
          }
        }
        this.fetchList();
      } catch (e) {
        console.log('移动失败==>', e);
      }
    },

    gameEdit(id) {
      const prepare = id
        // ? gameManageServer.queryGameSceneDetail({ id })// $http.get(`${this.gameUrl(1)}/${id}`)
        ? $http.get(`${this.gameUrl(1)}/${id}`)
        : Promise.resolve(null);
      prepare
        .then((res) => {
          this.editor.data = res;
        })
        .then(() => {
          this.editor.visible = true;
        });
    },

    gamePreview(id, url, game_question_type) {
      const prepare = $http.get(`${this.gameUrl()}/${id}`);
      prepare
        .then((res) => {
          this.preview.question_type = game_question_type;
          this.preview.type = this.type;
          this.preview.url = url;
          this.preview.data = res;
        })
        .then(() => {
          this.preview.visible = true;
        });
    },

    // 禁用或启用
    async gameJinyong(data, type) {
      console.log('禁用==>', data, type);
      try {
        let res = null;
        // 当data.enabled_status为1表示当前是启用,为2表示当前是禁用,开关取反
        switch (`${type}`) {
          case '30':
            console.log('课中');
            res = await gameManageServer.updateResource({ id: data.id, status_code: data.enabled_status === 1 ? 2 : 1 });
            break;
          case '666':
            console.log('游戏包');
            res = await gameManageServer.updateGamePack({ id: data.id, status_code: data.enabled_status === 1 ? 2 : 1 });
            break;
          default:
        }
        this.fetchList();
      } catch (e) {
        this.$message.error('编辑失败');
      }
    },

    gameResponse(id) {
      id || Number(this.$route.query.page) === 1
        ? this.fetchList2()
        : this.$list_routePageIndex(1, this.route);
    },

    // 新增
    selectChange(e, node) {
      console.log("retro11251358==>", e, node);
    },
    // 添加二级回调
    onAddMenu() {
      this.initMenu({ twoFlash: true });
      this.$message.success('添加成功');
    },
    // 添加二级目录
    handleAddMenu(parentId) {
      this.parentId = parentId;
      this.isAddMenu = true;
    },
    // 清除设置
    clearAll() {
      this.optId = '';
    },
  },
};
</script>

<template>
  <div
    v-loading="loading.fetch"
    class="layout-screen view-game"
  >
    <TheHeader />
    <div class="content-box">
      <AppTree
        :form="menuOne"
        :select="menuOneSelect"
        @onBack="onBack"
      />
      <div class="list-box">
        <div class="search-box-game">
          <div>
            <menu-item
              :data="menu"
              :value="menuSelect"
              @change="queryTypeOne"
            />
            <menu-item
              :data="menuTwo"
              :value="menuTwoSelect"
              @change="queryType"
            />
          </div>
          <div class="btn-box-game">
            <el-dropdown @command="handleAddMenu">
              <el-button
                type="primary"
                size="small"
                @command="selectChange">
                新建目录<i class="el-icon-arrow-down el-icon--right"/>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item,index) in menu"
                  :key="index"
                  :command="item.id">{{ item.value }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="select-box-game">
              <el-select
                v-if="isGameOut"
                v-model="selectValue"
                size="small"
                class="sel"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in selectData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
              </el-select>
              <AppQueryName
                :value.sync="searchText"
                class="search"
                @query="queryName"
              />
            </div>
          </div>
        </div>

        <AppList>
          <AppLabel
            v-if="!isUnTowLog"
            class="view-game__item"
            @create="gameEdit"
          />

          <GameItem
            v-for="item in list.data"
            :key="item.id"
            :data="item"
            :type="type"
            :grandpa="menuOneSelect"
            :is-jinyong="isJinyong"
            :is-fuzhi-permissions="getFuzhiPermissions"
            :is-move-permissions="getMovePermissions"
            class="view-game__item"
            @delete="gameDelete"
            @fuzhi="gameFuzhi"
            @move="gameMove"
            @update="gameEdit"
            @preview="gamePreview"
            @jinyong="gameJinyong"
          />
        </AppList>
      </div>
    </div>

    <GamePackEditor
      v-if="`${menuSelect}` === `666`"
      :visible.sync="editor.visible"
      :data="editor.data"
      :type="menuTwoSelect"
      @success="gameResponse"
    />
    <GameEditor
      v-else-if="`${menuSelect}` === `30`"
      :visible.sync="editor.visible"
      :data="editor.data"
      :type="menuSelect"
      :type-two="menuTwoSelect"
      @success="gameResponse"
    />
    <EditScene
      v-else-if="isTemp"
      :is-show.sync="editor.visible"
      :type="menuTwoSelect"
      :parent-type="menuSelect"
      :data="editor.data"
      :is-scene="isTemp && `${menuSelect}` === '6'"
      @success="gameResponse"
    />
    <ListConfigEditor
      v-else
      :visible.sync="editor.visible"
      :data="editor.data"
      :type="menuSelect"
      :type-two="menuTwoSelect"
      @success="gameResponse"
    />
    <GamePreview
      v-if="preview.visible"
      :visible.sync="preview.visible"
      :type="preview.type"
      :data="preview.data"
      :question_type="preview.question_type"
      :url="preview.url"/>

    <TheFooter>
      <AppPagination
        :list="list"
        :size="query.per_page"
        class="view-game__pagination"
        router
      />
    </TheFooter>
    <AppCopyOrMove
      :visible.sync="isCopyOrMove"
      :data="showData"
      :type="showType"
      @success="onCopyOrMove"
    />

    <AddMenu
      :visible.sync="isAddMenu"
      :parent-id="parentId"
      :is-temp="isTemp"
      @success="onAddMenu"
    />
  </div>
</template>

<style lang="postcss">
  .content-box{
    display: flex;
    flex-direction: row;
    min-height: calc(100vh - 60px);
  }
  .list-box{
    display: flex;
    flex-direction: column;
    min-width: calc(100% - 201px);
  }
.view-game {
  display: flex;
  flex-direction: column;
}

.view-game__item {
  margin: 15px;
}
/*.view-game .view-game__item{*/
  /*width: 280px !important;*/
/*}*/

.view-game__pagination {
  margin: auto;
}
.search-box-game{
  padding: 20px 30px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}
.btn-box-game{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.select-box-game {
  display: flex;
}
.select-box-game .sel{
  margin-right: 10px;
  width: 160px;
  margin-top: 10px;
}
.select-box-game .search{
  margin-top: 10px;
}
</style>
